import { DocumentsManager } from "us.collection.input-output/constants/Actions";
import { initialState } from "./State";
import {
  getMappedDocumentsIds,
  mergeMappedDocumentsIds,
  normalizeToArray,
  sortDocumentsByDocumentId,
  sortKeys,
} from "us.collection.input-output/functions";
import _ from "lodash";

const {
  GET_DOCUMENT_CATEGORIES,
  GET_DOCUMENT_CATEGORIES_SUCCESS,
  GET_DOCUMENT_CATEGORIES_FAIL,

  GET_ENTITY_DATA,
  GET_ENTITY_DATA_SUCCESS,
  GET_ENTITY_DATA_FAIL,

  ASSIGN_TO_CASE,
  ASSIGN_TO_CASE_SUCCESS,
  ASSIGN_TO_CASE_FAIL,

  RESET_ASSIGNED_DOCUMENTS,
  RESET_ASSIGNED_DOCUMENTS_SUCCESS,
  RESET_ASSIGNED_DOCUMENTS_FAIL,
} = DocumentsManager;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_DOCUMENT_CATEGORIES:
      return Object.assign({}, state, {
        documentCategories: {
          ...state.documentCategories,
          isLoading: true,
        },
      });
    case GET_DOCUMENT_CATEGORIES_SUCCESS:
      return Object.assign({}, state, {
        documentCategories: {
          data: payload?.data,
          isLoading: false,
        },
      });
    case GET_DOCUMENT_CATEGORIES_FAIL:
      return Object.assign({}, state, {
        documentCategories: {
          ...state.documentCategories,
          isLoading: false,
        },
      });
    case GET_ENTITY_DATA:
      return Object.assign({}, state, {
        entityInfo: {
          data: "",
          isLoading: true,
        },
      });
    case GET_ENTITY_DATA_SUCCESS:
      return {
        ...state,
        entityInfo: {
          data: payload?.data?.data ?? "",
          isLoading: false,
          keys: payload?.data?.params?.key ?? payload?.data?.params ?? null,
        },
      };
    case GET_ENTITY_DATA_FAIL:
      return Object.assign({}, state, {
        entityInfo: {
          ...state.documentCategories,
          isLoading: false,
        },
      });
    case ASSIGN_TO_CASE:
      return Object.assign({}, state, {
        caseAssignmentResult: {
          ...state.caseAssignmentResult,
          isLoading: true,
        },
        entityInfo: {
          data: "",
          isLoading: true,
        },
      });
    case ASSIGN_TO_CASE_SUCCESS:
      const { data, params } = payload?.data ?? {};
      const rawKeys = normalizeToArray(params?.keys);
      const sortedKeys = rawKeys.length ? sortKeys(rawKeys) : [];
      const sortedData = sortDocumentsByDocumentId(data);
      const existingMapped =
        state?.caseAssignmentResult?.mappedDocumentsIds || [];
      const newMapped = getMappedDocumentsIds(sortedData, sortedKeys);
      const mergedSorted = mergeMappedDocumentsIds(existingMapped, newMapped);

      return Object.assign({}, state, {
        caseAssignmentResult: {
          data: params ?? null,
          keys: sortedKeys,
          isLoading: false,
          mappedDocumentsIds: mergedSorted,
        },
        entityInfo: {
          data: "",
          isLoading: false,
        },
      });
    case ASSIGN_TO_CASE_FAIL:
      return Object.assign({}, state, {
        caseAssignmentResult: {
          ...state.caseAssignmentResult,
          isLoading: false,
        },
        entityInfo: {
          data: "",
          isLoading: false,
        },
      });
    case RESET_ASSIGNED_DOCUMENTS_SUCCESS: {
      const removedIds: number[] = payload?.data?.documentIds ?? [];
      const existingMapped: any[] =
        (state.caseAssignmentResult &&
          state.caseAssignmentResult.mappedDocumentsIds) ||
        [];

      const filtered = existingMapped.filter(
        (doc: any) => !removedIds.includes(Number(doc.documentId)),
      );

      return Object.assign({}, state, {
        caseAssignmentResult: {
          data: [],
          keys: [],
          mappedDocumentsIds: filtered,
          isLoading: false,
        },
        entityInfo: {
          data: "",
          isLoading: true,
        },
      });
    }

    case RESET_ASSIGNED_DOCUMENTS_FAIL:
      return {
        ...state,
        caseAssignmentResult: {
          ...state.caseAssignmentResult,
          isLoading: false,
        },
      };
    default:
      return state;
  }
};
